import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../../core/services/auth.service';
import { InactivityService } from '../../../../../core/services/inactivity.service';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-session-expired-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.scss']
})
export class SessionExpiredModalComponent implements OnInit, OnDestroy {
  visible: boolean = false;
  countdownSeconds: number = 60; // 60 segundos para cerrar sesión automáticamente
  private countdownSubscription?: Subscription;

  constructor(
    private inactivityService: InactivityService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Suscribirse al evento de sesión expirada
    this.inactivityService.sessionExpired.subscribe(expired => {
      this.visible = expired;
      if (expired) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    });
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  /**
   * Inicia la cuenta regresiva para el cierre de sesión automático
   */
  private startCountdown(): void {
    this.countdownSeconds = 60;
    this.stopCountdown(); // Por si acaso hay una suscripción anterior

    this.countdownSubscription = interval(1000)
      .pipe(take(this.countdownSeconds))
      .subscribe(() => {
        this.countdownSeconds--;
        if (this.countdownSeconds <= 0) {
          this.iniciarSesion(); // Cierre automático cuando llega a cero
        }
      });
  }

  /**
   * Detiene la cuenta regresiva
   */
  private stopCountdown(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = undefined;
    }
  }

  /**
   * Maneja el click en el botón de iniciar sesión
   */
  iniciarSesion(): void {
    this.stopCountdown(); // Detener la cuenta regresiva primero
    
    // Reiniciamos el estado de inactividad
    this.inactivityService.resetSessionState();
    
    // Cerramos la sesión actual y redirigimos a la página de inicio de sesión
    this.authService.signOutApply().then(() => {
      // La redirección a la página de login ya está manejada en signOutApply
    }).catch(error => {
      console.error('Error al cerrar sesión:', error);
      // En caso de error, intentamos redireccionar manualmente
      this.router.navigate(['/auth/login']);
    });
  }
}